// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueLocalStorage from 'vue-localstorage'
import VueSocketio from 'vue-socket.io-extended';
import io from 'socket.io-client';
import { createStore } from './store/index'
import './assets/css/animations.css'

Vue.use(VueLocalStorage)

// Vue.use(VueSocketio, io('http://localhost:3000'))
Vue.use(VueSocketio, io('https://calipso3407.aunnaitapp.es:3000'))

Vue.use(Vuetify, { theme: {
  primary: '#FFFFFF',
  secondary: '#E0E0E0',
  accent: '#BDBDBD',
  error: '#FF5252',
  info: '#00BCD1', 
  success: '#79C588',
  warning: '#FFC107'
}})

Vue.config.productionTip = false

const store = createStore()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  localStorage: {      
    cocToken: {
      type: String,
      default: null
    }
  },   
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js